var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart40 = function SvgHeart40(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M28.88 1.2C34.463 1.2 39 5.748 39 11.38c0 6.667-3.081 11.995-6.92 15.93-3.853 3.946-8.407 6.423-11.163 7.364l-.01.003c-.2.07-.529.123-.907.123s-.707-.053-.907-.123l-.01-.003-.537-.194c-2.786-1.062-7.014-3.47-10.625-7.17C4.08 23.375 1 18.047 1 11.38 1 5.748 5.537 1.2 11.12 1.2c3.309 0 6.237 1.598 8.077 4.076a1 1 0 0 0 1.606 0A10.06 10.06 0 0 1 28.88 1.2"
  })));
};
export default SvgHeart40;